import { Pipe, PipeTransform } from '@angular/core';

import { IAdditionalComponentsCatalogueCart } from '../../enclosure/models/product-accessories.model';
import { NumberOfAdditionalComponentsInCartPipe } from './number-of-additional-components-in-cart.pipe';
import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'noProductsAdded',
    standalone: false
})
export class NoProductsAddedPipe implements PipeTransform {

  transform(additionalComponentsAdded: IAdditionalComponentsCatalogueCart[], adjustedExistingProducts: IBomModel[] ): boolean {
    return !(new NumberOfAdditionalComponentsInCartPipe().transform(additionalComponentsAdded)) && !adjustedExistingProducts?.length;
  }

}
